import { State } from '@progress/kendo-data-query';

export const DEFAULT_GRID_STATE: State = {
  filter: {
    logic: 'and',
    filters: []
  },
  sort: [{
    field: 'dateIssued',
    dir: 'desc'
  }],
  take: 10,
  skip: 0
};
export const DEFAULT_FILTER = 'ALL';

export const SR_TOPICS_TC = 40;
export const ORIGINATOR_TC = 2;
export const ADDRESSEE_TC = 50;
export const ORIGIN_TC = 1125;

export const SRIS_REFERENCE_ID = 2;

export const SR_TOPICS_FORM_FIELD = 'srTopicsEqual';
export const SR_TOPICS_TITLE = 'Topics';
export const SR_TOPICS_DESCRIPTION = 'Select the Topic you want to filter by';
export const ADDRESSEE_FORM_FIELD = 'addresseeEqual';
export const ADDRESSEE_TITLE = 'Addressee';
export const ADDRESSEE_DESCRIPTION = 'Select the Addressee you want to filter by';

export const GENERAL_FILTER = {
  ALL: 'ALL',
  THIS_YEAR: 'THISYEAR',
  LAST_YEAR: 'LASTYEAR',
  UNION_WIDE_RELEVANCE: 'UNION',
  GLOBAL_CONCERN: 'GLOBAL',
};

export const GENERAL_FILTER_LABEL = {
  ALL: 'All',
  THISYEAR: 'This year',
  LASTYEAR: 'Last year',
  UNION: 'Union-Wide Relevance',
  GLOBAL: 'Global Concern',
};

export const GRID_STATE_SESSION_STORAGE_KEY = 'gridState';
export const SEARCH_DATA_SESSION_STORAGE_KEY = 'searchData';
export const FILTER_SESSION_STORAGE_KEY = 'filter';
export const ADVANCED_FILTER_IS_OPEN_SESSION_STORAGE_KEY = 'advancedFilterIsOpen';
export const HEADER_SEARCH_TERM_SESSION_STORAGE_KEY = 'headerSearchTerm';
export const ORIGINATOR_LIST_STORAGE_KEY = 'originatorList';
export const ORIGIN_LIST_STORAGE_KEY = 'originList';
export const SHOW_VERSIONS_STORAGE_KEY = 'show-versions';
